export const mediaQuery = {
    tablet: 'screen and (min-width: 768px)',
    /** desktop: 1024px */
    desktop: 'screen and (min-width: 1024px)',
    /** large desktop: 1200px */
    largeDesktop: 'screen and (min-width: 1200px)',
    /** x large desktop: 1366px */
    xLargeDesktop: 'screen and (min-width: 1366px)',
    /** xx large desktop: 1440px */
    xxLargeDesktop: 'screen and (min-width: 1440px)',
    /** xx large desktop: 1600px */
    xxxLargeDesktop: 'screen and (min-width: 1600px)',
    /** xx large desktop: 1920px */
    xxxxLargeDesktop: 'screen and (min-width: 1920px)',
};
